export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de reportes"])},
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicar filtros"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar"])}
        }
      },
      "en": {
        "labels": {
          "filter_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])},
          "download_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download"])}
        }
      }
    }
  })
}